import React from "react";
import { getUsesPerDayChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";
import { getExperienceSChartOptions } from "../../../../utils/chartOptions/dashboard/experiences";
import CustomTooltip from "../../../sharedComponents/CustomTooltip";
import ChartComponent from "./ChartComponent";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { AVERAGE_WEEKLY_FREQUENCY_TEXT } from "../../../../utils/constants";

const ChartSectionBlock = React.memo(function ChartSectionBlock({
  chartData,
  chartTypeText,
  chartSubText,
  tooltipSubtext,
  loading = false,
}) {
  let options;
  if (chartTypeText === AVERAGE_WEEKLY_FREQUENCY_TEXT) {
    options = getUsesPerDayChartOptions(chartData);
  } else {
    options = getExperienceSChartOptions(
      chartData,
      chartTypeText === "Brand Preference" ? "Single" : "Mean",
    );
  }

  return (
    <>
      <div className="mb-3" style={{ width: "100%" }}>
        {/* // handled loading on parent to show custom cols so not required here */}
        {/* {loading ? (
          <ChartSkeleton />
        ) : (
          <ChartComponent type="bar" data={chartData} options={options} />
        )} */}
        <ChartComponent type="bar" data={chartData} options={options} />
      </div>

      <CustomTooltip
        tooltipHeading={chartTypeText}
        tooltipSubtext={tooltipSubtext}
      >
        <div className="tooltip-section d-flex justify-content-center">
          {/* <Tooltip target=".tooltip-content" position="top" className="custom-tooltip text-center" style={{ backgroundColor: '#9E9E9E' }}>
                        <div className="tooltip-contenth p-1" style={{ backgroundColor: '#9E9E9E' }}>
                            <div className="text-uppercase">Frequency</div>
                            <div className="text-uppercase sub-text">Average count of uses per week per product</div>
                        </div>
                    </Tooltip> */}
          <div className="tooltip-content py-1 px-2 text-center">
            <div className="heading-text">{chartTypeText}</div>
            <div className="sub-text">({chartSubText})</div>
          </div>
        </div>
      </CustomTooltip>
    </>
  );
});

export default ChartSectionBlock;
